/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Photos_TitleInputs */

const cs_projects_photos_title = /** @type {(inputs: Projects_Photos_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotky projektu`)
};

const en_projects_photos_title = /** @type {(inputs: Projects_Photos_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project photos`)
};

/**
* | output |
* | --- |
* | "Project photos" |
*
* @param {Projects_Photos_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_photos_title = /** @type {((inputs?: Projects_Photos_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Photos_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_photos_title(inputs)
	return cs_projects_photos_title(inputs)
});